import { LicenseTypeNature } from '../../../types';

import type { RootState } from '../../../store';

export const newLicensesSelector =
  (licenseTypeNature = LicenseTypeNature.LPCO) =>
  (state: RootState) =>
    state.licenses[licenseTypeNature].newLicenses;
export const licensesSelector =
  (licenseTypeNature = LicenseTypeNature.LPCO) =>
  (state: RootState) =>
    state.licenses[licenseTypeNature].licenses;
